import { render, staticRenderFns } from "./PromoteurEditModal.vue?vue&type=template&id=37d23f23&"
import script from "./PromoteurEditModal.vue?vue&type=script&lang=js&"
export * from "./PromoteurEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports